import Vue from 'vue';
import Router from 'vue-router';
import TrainingVideo from "../views/registration/TrainingVideo";
import RegistrationComplete from "@/views/registration/RegistrationComplete";
import Start from "@/views/registration/Start";
import Notfound from "@/views/Notfound";
import Expired from "@/views/Expired";
import Test from "@/views/Test";
import store from '../store'
import localForageService from "@/localForageService";
import {config} from "@/config";
import PreAgent from "@/views/registration/PreAgent";
import CompletePage from "../views/registration/CompletePage";
import InfoVerification from "../views/registration/InfoVerification";
import MobileVerification from "../views/registration/MobileVerification";
import Undertaking from "../views/registration/Undertaking";
import AccountType from "../views/registration/AccountType";
import Test2 from "@/views/Test2";
Vue.use(Router);

let router = new Router({
    routes: [
        {
            path: '/',
            name: 'Start',
            component: Start,
        },
        {
            path: '/training',
            name: 'TrainingVideo',
            component: TrainingVideo,

        },
        {
            path:'/pre-agent',
            name:'PreAgent',
            component:PreAgent,
            beforeEnter: (to, from, next) => {
                if (store.state.selected_agent !== null) {
                    next()
                }
                else {
                    next('/complete')
                }
            }
        },
        {
            path: '/verify-agent',
            name: 'AgentVerification',
            component: ()=>import('../views/registration/AgentVerification'),

        },
        {
            path:'/complete-page',
            name:'CompletePage',
            component:CompletePage,
        },
        {
            path:'/undertaking',
            name:'Undertaking',
            component:()=>import('../views/registration/Undertaking.vue'),
        },
        {
            path:'/account-options',
            name:'AccountType',
            component:()=>import('../views/registration/AccountType.vue'),
        },
        {
            path:'/info-verification',
            name:'InfoVerification',
            component:()=>import('../views/registration/InfoVerification.vue'),
        },
        {
            path:'/mobile-verification',
            name:'MobileVerification',
            component:()=>import('../views/registration/MobileVerification.vue'),
        },
        {
            path: '/detect-face',
            name: 'FaceDetection',
            component: ()=>import('../views/registration/FaceDetection.vue'),

        },
        {
            path: '/detect-document',
            name: 'DocumentDetection',
            component: ()=>import('../views/registration/DocumentDetection.vue'),
            // eslint-disable-next-line no-unused-vars
            beforeEnter: (to, from, next) => {
                if (store.state.session_id === null) {
                    next('/')
                }
                else {
                    next()
                }
            }
        },
        {
            path: '/complete',
            name: 'RegistrationComplete',
            component: RegistrationComplete,
        },
        {
            path: '/test',
            name: "Test",
            component: Test
        },
        {
            path: '/test2',
            name: "Test2",
            component: Test2
        },
        {
            path: '/expired',
            name: "Expired",
            component: Expired
        },
        {
            path: '*',
            name: "NotFound",
            component: Notfound
        },

    ],
    mode: "history"
});
function hasQueryParams(route) {
    return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
        if (to.name !== 'Expired' && to.name !== 'Test' && to.name !== 'CompletePage' && to.name!=='Test2'){
            if(!hasQueryParams(to) && hasQueryParams(from)){
                if ('key' in from.query && 'meta' in from.query){
                    next({path: to.path, query: from.query});

                }
                else {
                    next('/expired')
                }

            } else {
                if ('key' in to.query && 'meta' in to.query){
                    next()
                }
                else {
                    next('/expired')
                }
            }
        }
        else {
            next()
        }



})
export default router;
